import { UniStorageFactory } from '@lmt/unicorn-shared/app/helpers/uni-storage';

export function initWebStorage(): void {
  UniStorageFactory.initWebStorage(
    process.env?.REACT_APP_BACKEND_URI || window.location.origin,
  );
}
